<fgb-page-header
  [pageTitle]="'wallet.redeemed.title'"
  [showBalance]="false"
  [backButtonLink]="'/rewards/wallet'"
/>
<div class="container">
  <div class="d-none d-lg-block align-items-center pb-2" style="padding-top: 30px">
    <!-- Back Button -->
    <div
      class="reward-back-btn-bg mt-0 cursor-pointer d-flex align-items-center justify-content-center"
      [routerLink]="'/rewards/wallet'"
    >
      <span class="material-icons icons ms-2 text-white"> arrow_back_ios </span>
    </div>
    <!-- Title -->
    <h5 class="m-0 mt-3 text-black wallet-redeemed-title text-capitalize">
      {{ "wallet.redeemed.title" | translate }}
    </h5>
    <div class="back-button"></div>
  </div>

  <!-- Offer history -->
  <fgb-campaigns-v2-used-offers-list></fgb-campaigns-v2-used-offers-list>

  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container
      *ngIf="
        walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length;
        else noWalletItems
      "
    >
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [style]="'list'"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="no-items w-100 text-center border rounded py-4 bg-white">
    <p class="text-black text-center font-size-14 mb-0">
      {{ "claimed.rewards.placeholder.description" | translate }}
    </p>
  </div>
</ng-template>
